// Centralized route builders for internal navigation
// Always use these instead of hard-coded strings
import { getFrontendOrigin } from './urls';

export const routes = {
  home: () => '/',
  dashboard: () => '/dashboard',
  account: () => '/account',
  billing: {
    success: () => '/billing/success',
    cancel: () => '/billing/cancel',
  },
  project: {
    root: (projectId: string) => `/project/${projectId}`,
    gallery: (projectId: string) => `/project/${projectId}/gallery`,
    file: (projectId: string, fileId: string) => `/project/${projectId}/files/${fileId}`,
    figures: {
      list: (projectId: string) => `/project/${projectId}/figures`,
      new: (projectId: string) => `/project/${projectId}/figures/new`,
      edit: (projectId: string, figureId: string) => `/project/${projectId}/figures/${figureId}`,
    },
  },
  plotEditor: {
    new: () => '/plot-editor/new',
    open: (projectId: string, plotId?: string) =>
      plotId ? `/plot-editor/${projectId}/${plotId}` : `/plot-editor/${projectId}`,
  },
  share: (token: string) => `/share/${token}`,
  help: () => '/help',
  legal: {
    // Legal pages are hosted on blog.lumiplot.ai, not in the SPA
    terms: () => `${getFrontendOrigin().replace(/\/$/, '')}/terms`,
    privacy: () => `${getFrontendOrigin().replace(/\/$/, '')}/privacy`,
    data: () => `${getFrontendOrigin().replace(/\/$/, '')}/data`,
  },
};

export default routes;


